import { render } from "./AddressSearch.vue?vue&type=template&id=0d1edc62"
import script from "./AddressSearch.vue?vue&type=script&lang=js"
export * from "./AddressSearch.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__